import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AppCore from "./AppCore";
import LandingPage from "./LandingPage";
import LoginPage from "./LoginPage";
import RegisterPage from "./RegisterPage";
import "./App.css";

function App() {
  const [token, setToken] = useState(localStorage.getItem("access_token") || "");
  const [refreshToken, setRefreshToken] = useState(localStorage.getItem("refresh_token") || "");
  const [authMode, setAuthMode] = useState("login");
  const [loginError, setLoginError] = useState(null);
  const API_BASE = process.env.REACT_APP_API_BASE;
  
  useEffect(() => {
    const verifyToken = async () => {
      if (!token) return;
      try {
        const res = await fetch(`${API_BASE}/auth/verify-token`, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Invalid token");
      } catch (err) {
        console.error("Token verification failed:", err);
        handleLogout();
      }
    };
    verifyToken();
  }, [token]);

  const handleLogin = async (email, password) => {
    setLoginError(null);
    try {
      const res = await fetch(`${API_BASE}/auth/token`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ username: email, password }),
      });
      if (!res.ok) throw new Error("Invalid credentials");
      const data = await res.json();
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);
      setToken(data.access_token);
      setRefreshToken(data.refresh_token);
    } catch (err) {
      setLoginError(err.message);
    }
  };

  const handleRegister = async (email, password, org, passkey) => {
    setLoginError(null);
    try {
      const res = await fetch(`${API_BASE}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, organization: org, passkey }),
      });
      if (!res.ok) throw new Error("Registration failed");
      alert("Registration successful! You can now log in.");
    } catch (err) {
      setLoginError(err.message);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    setToken("");
    setRefreshToken("");
  };

  const PrivateRoute = ({ children }) => {
    return token ? children : <Navigate to="/login" replace />;
  };

  const PublicRoute = ({ children }) => {
    return !token ? children : <Navigate to="/app" replace />;
  };

  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <PublicRoute>
            <LandingPage />
          </PublicRoute>
        } />
        <Route path="/login" element={
          <PublicRoute>
            <LoginPage handleLogin={handleLogin} setAuthMode={setAuthMode} loginError={loginError} />
          </PublicRoute>
        } />
        <Route path="/register" element={
          <PublicRoute>
            <RegisterPage handleRegister={handleRegister} setAuthMode={setAuthMode} registerError={loginError} />
          </PublicRoute>
        } />
        <Route path="/app" element={
         <PrivateRoute>
            <AppCore 
              token={token} 
              refreshToken={refreshToken} 
              handleLogout={handleLogout} 
            />
          </PrivateRoute>
       } />
      </Routes>
    </Router>
  );
}

export default App;